module.exports = __webpack_public_path__ + "static/media/otp_icon_upload.4ce6e26f.gif";